import Href from '@sdk/components/ui/Href';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import TranslateWithComponents from '@sdk/lang/TranslateWithComponents';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import isToday from '@sdk/utils/dateUtils/isToday';

import { ClickableText } from '@web/roster/EmptyStates/components/TextSecondLine.styles';

type Props = {
  date: string;
  hasShiftsWithinTwoWeeks: boolean;
  showResetFilters: boolean;
  clearFilters: () => void;
};

const TextSecondLine = ({
  date,
  hasShiftsWithinTwoWeeks,
  showResetFilters,
  clearFilters,
}: Props) => {
  if (showResetFilters) {
    return (
      <Text14 textAlign="center" themeColor={ThemeColorType.gray} semiBold>
        <TranslateWithComponents
          replaceComponents={{
            linkComponent: (
              <ClickableText onClick={clearFilters} semiBold themeColor={ThemeColorType.primary}>
                {gettext('Reset filters')}
              </ClickableText>
            ),
          }}>
          {isToday(date)
            ? gettext('[[linkComponent]] or check back later.')
            : gettext('[[linkComponent]] or change the date.')}
        </TranslateWithComponents>
      </Text14>
    );
  }

  if (!hasShiftsWithinTwoWeeks) {
    return (
      <Text14 textAlign="center" themeColor={ThemeColorType.gray} semiBold>
        <TranslateWithComponents
          replaceComponents={{
            linkComponent: (
              <Href
                themeColor={ThemeColorType.primary}
                semiBold
                fontSize={14}
                href={`/shifts?date=${date}&mode=day&tab=alllocations`}
                hoverTextDecoration="none">
                {gettext('Build the schedule')}
              </Href>
            ),
          }}>
          {gettext('[[linkComponent]] or check back later.')}
        </TranslateWithComponents>
      </Text14>
    );
  }

  return (
    <Text14 textAlign="center" themeColor={ThemeColorType.gray} semiBold>
      {gettext('Change the date or check back later.')}
    </Text14>
  );
};

export default TextSecondLine;
